import React from 'react';

import { connect } from 'react-redux';
import { hideSponsoredWarning } from 'services/actions/productsActions';
import { requestRemoveFromCart } from 'services/actions/cartActions';
import { gwpModalDefaultContentStyles } from './GwpModalDefaultContentStyles';

import BaseModal from '../../../shared-components/BaseModal/Modal';
import GwpPopupsContentWrapper from './GwpPopupsContentWrapper';

const RemoveGWPOutOfStockPopup = (props) => {
  const {
    shouldDisplayRemoveGWPOutOfStockPopup,
    hideSponsoredWarning,
    requestRemoveFromCart,
  } = props;

  return (
    <BaseModal
      showCloseIcon={false}
      isOpen={shouldDisplayRemoveGWPOutOfStockPopup}
      onRequestClose={hideSponsoredWarning}
      shouldCloseOnOverlayClick
      styles={gwpModalDefaultContentStyles}
    >
      <GwpPopupsContentWrapper
        title="Are You Sure You Want to Remove This Product?"
        description="We’re sorry, the lower value mystery gift is out of stock. Deleting this item could disqualify your free gift all together."
        requestRemoveFromCart={requestRemoveFromCart}
        hideSponsoredWarning={hideSponsoredWarning}
      />
    </BaseModal>
  );
};

function mapStateToProps(state) {
  return {
    shouldDisplayRemoveGWPOutOfStockPopup:
      state.productsState.shouldDisplayRemoveGWPOutOfStockPopup,
  };
}

export default connect(mapStateToProps, {
  hideSponsoredWarning,
  requestRemoveFromCart,
})(RemoveGWPOutOfStockPopup);
